export default {
    save: 'حفظ',
    delete: 'حذف',
    edit: 'تعديل',
    cancel: 'إلغاء',

    'basic-data': 'بيانات أساسية',
    'material-name': 'اسم المادة',
    'main-material': 'المادة الرئيسية',
    'account-no-is-automatic-or-manual': 'رقم الحساب (آلي أو يدوي)',
    
    'material-type': {
        title: 'نوع المادة',
        main: 'أساسي',
        sub: 'فرعي',
    },

    'material-category':{
        title: 'تصنيف المادة',
        'commercial-ordinary-material': 'مادة عادية تجارية',
        'raw-material': 'مادة أولية',
        'indirect-raw-material': 'مادة أولية غير مباشرة',
        'material-under-manufacture': 'مادة تحت الصنع',
        'manufactured-material': 'مادة تامة الصنع',
    },

    'unit-size': 'وحدة القياس',
    'additional-data': 'بيانات إضافية',

    'min': 'الحد الأدنى',
    'max': 'الحد الأعلى',
    manufacturer: 'الشركة المُصنِعة',
    specifications: 'المواصفات/المصدر',

    'material-movement-data': 'بيانات حركة المادة',
    
    'purchasing-price': 'سعر الشراء',
    'selling-price': 'سعر البيع',
    'purchase-account': 'حساب المشتريات',
    'sales-account': 'حساب المبيعات',
    notes: 'ملاحظات',
    
    'delete-the-material': 'حذف المادة',
    'are-you-sure-you-want-to-delete-the-material-$': 'هل أنت متأكد من حذف المادة: {materialName}؟',
    
    'edit-material': 'تعديل مادة',
    'create-material': 'إنشاء مادة',
    'interlocking-materials': 'تشبيك مواد',
    'materials-that-have-the-same-barcode': 'المواد التي لها نفس الباركود',
    'confirm-disengagement-of-material': 'تأكيد فك ارتباط مادة',
    'are-you-sure-you-want-to-disconnect?': 'هل أنت متأكد من أنك تريد فك الارتباط المواد ؟'
}